import { useEffect, useState } from "react";

/** Custom properties for Pagination component
 * can be consumed by the parent element.
 */
type PaginationProps = {
    count       : number,
    totalPages  : number,
    currentPage : number,
    previous    : string, 
    next        : string

    /* Callback Method */
    onPageChange: (page: number) => void;
}

const Pagination = ({ onPageChange, totalPages, previous, next, currentPage }: PaginationProps) => {

    /**
     * Method handles page changes when user clicks on different page number than the current selected.
     * @param newPage: New page index.
     */
    function onPaginationChange(newPage: number): void {
        if (newPage <= totalPages && newPage !== currentPage && newPage > 0)
        {
            /* Use callback method to inform subscriber about pagination changes */
            onPageChange(newPage);
        }
    } 

    useEffect(() => {

    }, [])

    return (
        <nav>
            <ul className="pagination justify-content-end">

                {previous && previous !== "" &&
                    <li className="page-item">
                        <button className="page-link" onClick={e => onPaginationChange(currentPage - 1)}><i className="bi bi-chevron-double-left"></i></button>
                    </li>
                }

                {
                    Array.from({ length: totalPages }, (_, i) => i + 1).map((value, index) =>
                    {
                        return (
                            <li className="page-item" key={index}>
                                <button className={currentPage === value ? "page-link active" : "page-link"} onClick={e => onPageChange(Number(value))}>{value}</button>
                            </li>
                        )
                    })
                }

                {next && next !== "" &&
                    <li className="page-item">
                        <button className="page-link" onClick={e => onPaginationChange(currentPage + 1)}><i className="bi bi-chevron-double-right"></i></button>
                    </li>
                }

            </ul>
        </nav>
    )

}
export default Pagination;